import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: var(--space-1000);
`

export const ButtonContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`
